@if (isLoaded) {
    <div
        [ngClass]="{
            'two-equal-cells-row': isGalleryOfTwoEqualImages,
        }">
        @if (attachmentsCount >= 2) {
            <div
                [ngClass]="{
                    'first-horizontal': firstImageOrientation === 'horizontal',
                    'first-vertical': firstImageOrientation === 'vertical',
                    'four-equal-cells': isGalleryOfFourEqualImages,
                }">
                @if (attachmentsCount === 2) {
                    <div class="d-flex two-cells">
                        @for (image of attachment.attachments; track image; let i = $index) {
                            <div
                                class="gallery-cell"
                                [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                (click)="openInWindow(i)"></div>
                        }
                    </div>
                } @else if (attachmentsCount > 2) {
                    <div
                        [ngClass]="{
                            'd-flex': firstImageOrientation === 'vertical',
                            'three-cells': attachmentsCount === 3,
                            'four-and-more-cells': attachmentsCount >= 4,
                            'five-cells': isDisplayFiveImages,
                        }">
                        @if (isGalleryOfFourEqualImages) {
                            <div class="d-flex cell-row">
                                @for (image of attachment.attachments | slice: 0 : 2; track image; let i = $index) {
                                    <div
                                        class="gallery-cell"
                                        [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                        (click)="openInWindow(i)"></div>
                                }
                            </div>
                            <div class="d-flex cell-row">
                                @for (image of attachment.attachments | slice: 2; track image; let i = $index) {
                                    <div
                                        class="gallery-cell"
                                        [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                        (click)="openInWindow(i + 2)"></div>
                                }
                            </div>
                        } @else {
                            @if (!isDisplayFiveImages) {
                                <div
                                    class="gallery-cell first-image"
                                    (click)="openInWindow(0)"
                                    [ngStyle]="{
                                        'background-image': 'url(' + attachment.attachments[0].url + ')',
                                    }"></div>
                            }

                            @if (attachmentsCount < 5) {
                                <div class="d-flex cell-row">
                                    @for (
                                        image of attachment.attachments;
                                        track image;
                                        let i = $index;
                                        let isFirst = $first
                                    ) {
                                        @if (isFirst) {
                                            <div
                                                class="gallery-cell"
                                                [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                                (click)="openInWindow(i)"></div>
                                        }
                                    }
                                </div>
                            }

                            @if (attachmentsCount >= 5) {
                                @if (isDisplayFiveImages) {
                                    <div class="d-flex cell-row">
                                        @for (
                                            image of attachment.attachments | slice: 0 : 2;
                                            track image;
                                            let i = $index
                                        ) {
                                            <div
                                                class="gallery-cell"
                                                [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                                (click)="openInWindow(i)"></div>
                                        }
                                    </div>
                                    <div class="d-flex cell-row">
                                        @for (
                                            image of attachment.attachments | slice: 2 : 5;
                                            track image;
                                            let i = $index;
                                            let isLast = $last
                                        ) {
                                            @if (!isLast) {
                                                <div
                                                    class="gallery-cell"
                                                    [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                                    (click)="openInWindow(i + 2)"></div>
                                            } @else {
                                                <div
                                                    class="pointer position-relative w-100"
                                                    (click)="openInWindow(i + 2)">
                                                    @if (attachmentsCount > 5) {
                                                        <div class="dark-background">
                                                            +{{ attachment.attachments.length - 5 }}
                                                        </div>
                                                    }
                                                    <div
                                                        class="gallery-cell"
                                                        [ngStyle]="{
                                                            'background-image': 'url(' + image.url + ')',
                                                        }"></div>
                                                </div>
                                            }
                                        }
                                    </div>
                                } @else {
                                    <div class="d-flex cell-row">
                                        @for (
                                            image of attachment.attachments | slice: 0 : 4;
                                            track image;
                                            let i = $index;
                                            let isFirst = $first;
                                            let isLast = $last
                                        ) {
                                            @if (!isFirst && !isLast) {
                                                <div
                                                    class="gallery-cell"
                                                    [ngStyle]="{ 'background-image': 'url(' + image.url + ')' }"
                                                    (click)="openInWindow(i)"></div>
                                            }

                                            @if (isLast) {
                                                <div class="position-relative pointer w-100" (click)="openInWindow(i)">
                                                    <div class="dark-background">
                                                        +{{ attachment.attachments.length - 3 }}
                                                    </div>
                                                    <div
                                                        class="gallery-cell"
                                                        [ngStyle]="{
                                                            'background-image': 'url(' + image.url + ')',
                                                        }"></div>
                                                </div>
                                            }
                                        }
                                    </div>
                                }
                            }
                        }
                    </div>
                }
            </div>
        }
        @if (attachmentsCount < 2) {
            <div>
                <img
                    [src]="attachment.attachments[0].url || attachment.attachments[0].previewUrl"
                    class="image-preview w-100"
                    (click)="openInWindow(0)"
                    alt="attachment image" />
            </div>
        }
    </div>
} @else {
    <sb-loader></sb-loader>
}
